// Test IDs for the admin Review Queue (M5).
// See constants/testIds/index.js for conventions.

export const ADMIN_LOGIN = {
        screen: 'admin-login-screen',
        tokenInput: 'admin-token-input',
        submitButton: 'admin-login-submit-button',
        error: 'admin-login-error',
};

export const ADMIN_REVIEW = {
        page: 'admin-review-page',
        emptyState: 'admin-review-empty',
        loading: 'admin-review-loading',
        table: 'admin-review-table',
        row: (id) => `admin-review-row-${id}`,
        approveButton: (id) => `admin-review-approve-${id}`,
        rejectButton: (id) => `admin-review-reject-${id}`,
        rejectDialog: 'admin-review-reject-dialog',
        rejectReasonInput: 'admin-review-reject-reason-input',
        rejectConfirmButton: 'admin-review-reject-confirm-button',
        rejectCancelButton: 'admin-review-reject-cancel-button',
        logoutButton: 'admin-review-logout-button',
        countBadge: 'admin-review-count-badge',
        voicePanel: (id) => `admin-review-voice-${id}`,
        voiceContextChip: (id) => `admin-review-voice-context-${id}`,
        voiceGapChip: (id) => `admin-review-voice-gap-${id}`,
        voiceScoresList: (id) => `admin-review-voice-scores-${id}`,
        waitlistNavLink: 'admin-review-nav-waitlist',
};

export const ADMIN_WAITLIST = {
        page: 'admin-waitlist-page',
        loading: 'admin-waitlist-loading',
        emptyState: 'admin-waitlist-empty',
        table: 'admin-waitlist-table',
        row: (email) => `admin-waitlist-row-${email}`,
        countBadge: 'admin-waitlist-count-badge',
        exportButton: 'admin-waitlist-export-button',
        refreshButton: 'admin-waitlist-refresh-button',
        reviewNavLink: 'admin-waitlist-nav-review',
        logoutButton: 'admin-waitlist-logout-button',
};
